const PrivateRouteConst = {
  INPUT_FILE_UPLOAD: 'uploadInputDataFile',
  MASTER_FILE_UPLOAD: 'uploadmasterDataFile',
  START_PAYOUT: 'startPayout',
  CONFIG_TASK: 'configTask',
  RUN_SIMULATION: 'runSimulationView',
  VIEW_SIMULATION: 'allViewSimulationView',
  CONFIGURE_SIMULATION: 'allConfigureSimulationView',
  UNIFICATION_HISTORY: 'viewUnificationHistory',
  ACCOUNTING: 'accounting',
  INPUT_FILE_DOWNLOAD: 'downloadInputDataFile',
  MASTER_FILE_DOWNLOAD: 'downloadmasterDataFile',
  MY_TASK_DASHBOARD: 'allTasklistDashboardView',
  PAYOUT_HISTORY: 'viewPayoutHistory',
  UNIFICATION_VIEW: 'viewUnificationHistory',
  CHART_MAPPING_VIEW: 'chartMappingView',
  CHART_VIEW: 'chartView',
  DATA_SYNC: 'dataSync',
  SYNC_HISTORY: 'syncHistory',
  SYNC_MANAGEMENT: 'syncManagement',
  PERFORMANCE_DASHBOARD: 'allPerformanceDashboardView',
  PAYOUTREVIEWER_DASHBOARD: 'allPayoutReviewerDashboardView',
  MY_TASK: 'TaskView',
  TEAMLEAD_DASHBOARD: 'allTeamLeadDashboardView',
  TARGET_SETTING_VIEW: 'allTargetSettingView',
  TARGET_SETTING_LIST: 'targetSettingList',
  TARGET_OVERRIDE_VIEW: 'allTargetSettingView',
  HISTORICAL_VIEW: 'allTargetHistoricalReport',
  USER_PERFORMANCE_VIEW: 'allTargetUserPerformanceReport',
  SHOW_BUTTON: 'augment8ApplicationallShowButtons',
  SHOW_FORMULA: 'augment8ApplicationallShowFormula',
  EDIT_FORMULA: 'augment8ApplicationallEditFormula',
  CANCELLATION_FILE_UPLOAD: 'contractCancellationUploadExcel',
  NEED_TO_PAY_VIEW: 'needToPayView',
  UPLOAD_UTR_VIEW: 'uploadUtrView',
  PAYOUT_ADMIN: 'payoutAdminTaskView',
  DOWNLOAD_PAYOUT_REPORT: 'downloadPayoutReport',
  NO_DUES_CERTIFICATE_VIEW: 'noDuesCertificateView',
  HOLD_VIEW: 'holdView',
  RELEASE_VIEW: 'releaseView',
  HOLD_RELEASE_TASK_CONFIG_VIEW: 'holdReleaseTaskConfgView',
  CONTEST_HISTORY: 'viewContestHistory',
  RUN_CONTEST: 'runContest',
  EDIT_SIMULATION: 'allEditSimulationView',
  SELF_EDIT_SIMUALTION: 'selfEditSimulationView',
  DATA_CORRECTION: 'dataCorrection',
  // INPUT_FILE_DATA_CORRECTION: 'inputFileDataCorrection',
  // MASTER_FILE_DATA_CORRECTION: 'masterFileDataCorrection',
  TRIGGER_CLAWBACK_SCREEN: 'contractCancellationUpload',
  UPLOAD_DOWNLOAD_INPUT_FILES: 'UploadDownloadInputFiles',
  UPLOAD_DOWNLOAD_MATSER_FILES: 'UploadDownloadMasterFiles',
};
export default PrivateRouteConst;
